// extracted by mini-css-extract-plugin
export default {"spinner__wrapper":"LoadingSpinner_spinner__wrapper__Tw98q","spinner__wrapper__fullPage":"LoadingSpinner_spinner__wrapper__fullPage__h3w4v","spinner":"LoadingSpinner_spinner__40kOg"};